export default __webpack_public_path__ + "static/media/dbmi.0a7e3d03.png";